import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminPageEditSidebarLogoUploader from './LogoUploader';

const AdminPageEditSidebarHeaderSettings = ({
  page,
  handleChange,
}) => {
  const intl = useIntl();

  return (
    <div className="header-settings">
      <FormGroup>
        <Label for="inpHeader">
          {intl.formatMessage({ defaultMessage: 'Header type' })}
        </Label>
        <Input
          type="select"
          className="custom-select"
          name="header"
          id="inpHeader"
          bsSize="sm"
          defaultValue={page.options.header}
          onChange={handleChange}
        >
          <option value="transparent">
            {intl.formatMessage({ defaultMessage: 'transparent' })}
          </option>
          <option value="solid">
            {intl.formatMessage({ defaultMessage: 'solid' })}
          </option>
        </Input>
      </FormGroup>
      <AdminPageEditSidebarLogoUploader
        page={page}
        handleChange={handleChange}
      />
    </div>
  );
};

AdminPageEditSidebarHeaderSettings.propTypes = {
  page: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default AdminPageEditSidebarHeaderSettings;
